<template>
    <MasterTemplate 
        title="ข้อมูลตำแหน่ง" 
        :headers="headers" 
        :setData="setData"
        itemKey="positionCode"
        :getItemName="getItemName"
        :deleteData="deleteData"
        :insertData="insertData"
        :updateData="updateData"
        :listData="listData"
        >
        <template v-slot:formInput="{rules}">
            <v-row>
                <v-col cols="6" >
                    <v-text-field label="รหัสตำแหน่ง" autofocus maxlength="20" v-model="editedItem.positionCode" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="6" >
                    <v-text-field  label="ชื่อตำแหน่ง" maxlength="100" v-model="editedItem.positionName" :rules="[rules.required]"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" >
                    <v-checkbox label="ช่าง" value="T" v-model="editedItem.positionGroup"></v-checkbox>
                </v-col>
            </v-row>
        </template>
    </MasterTemplate>
</template>

<script>
/* eslint-disable */
import MasterTemplate from '@/components/MasterTemplate'
import {listPosition, insertPosition, deletePosition} from '@/api/master/position-api.js'

export default {
    name: 'Position',
    components: {
        MasterTemplate
    },
    computed: {
        chkCode() {
            if (this.isDup == true) return 'รหัสบริษัทซ้ำ';
            return true;
        }
    },
    data: () => ({
        isDup: false,
        headers: [
            {text: 'รหัสตำแหน่ง', value: 'positionCode'},
            {text: 'ชื่อตำแหน่ง', value: 'positionName'},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        editedItem: {
            positionCode: '',
            positionName: '',
            positionGroup: ''
        }
    }),
    methods: {
        listData() {
            return listPosition()
        },
        deleteData(item) {
            return deletePosition(item.positionCode);
        },
        insertData() {
            return insertPosition(this.editedItem);
        },
        getItemName(item) {
            return item.positionName;
        },
        setData(item) {
            this.editedItem = item;
        }
    }
}
</script>
